import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { config, isConfigValid } from '@/app/config';

let client: SupabaseClient | null = null;

export function getSupabase(): SupabaseClient | null {
  if (config.mode === 'demo') return null;
  if (!isConfigValid(config)) return null;
  if (!client) {
    client = createClient(config.supabaseUrl!, config.supabaseAnonKey!, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    });
  }
  return client;
}
